export class RegisterModel {
  constructor(model) {
    this.email = model.email;
    this.firstName = model.firstName;
    this.lastName = model.lastName;
    this.password = model.password;
    this.confirmPassword = model.confirmPassword;
    this.captcha = model.captcha;
  }
  // Getter
  get Validate() {
    return this.validateModel();
  }
  // Method
  validate() {
    const errors = {};
    if (!this.firstName) {
      errors.firstName = {
        message: 'Required',
        hasError: true
      };
    }
    if (!this.lastName) {
      errors.lastName = {
        message: 'Required',
        hasError: true
      };
    }
    if (!this.email) {
      errors.email = {
        message: 'Required',
        hasError: true
      };
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.email)) {
      errors.email = {
        message: 'Invalid email address',
        hasError: true
      };
    }
    if (!this.password) {
      errors.password = {
        message: 'Required',
        hasError: true
      };
    }
    if (!this.confirmPassword) {
      errors.confirmPassword = {
        message: 'Required',
        hasError: true
      };
    } else if (this.password !== this.confirmPassword) {
      errors.confirmPassword = {
        message: 'Passwords do not match',
        hasError: true
      };
    }
    if (!this.captcha) {
      errors.captcha = {
        message: 'Required',
        hasError: true
      };
    }
    return errors;
  }
}



// WEBPACK FOOTER //
// ./src/models/account/register.model.js